// frontend/src/pages/Dashboard/Home/index.jsx
import React from "react";
import styles from './index.module.css';
import KPICard from "./kpi-card";
import SalesVsCogs from "./salesvscogs";
import DailyOrder from "./dailyorder";
import DailySales from "./dailysales";
import OpenOrder from "./openorders";
import Timeline from "./timeline";
import Category from "./category";

const Home = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.componentsGrid}>
          
          {/* KPI Card */}
          <div className={`${styles.componentCard} ${styles.kpiCard}`}>
            <KPICard />
          </div>
          
          {/* Sales vs COGS */}
          <div className={`${styles.componentCard} ${styles.salesCogs}`}>
            <SalesVsCogs />
          </div>
          
          {/* Daily Order */}
          <div className={`${styles.componentCard} ${styles.dailyOrder}`}>
            <DailyOrder />
          </div>
          <div className={`${styles.componentCard} ${styles.dailyOrder}`}>
            <DailySales />
          </div>
{/*           
      
          <div className={`${styles.componentCard} ${styles.openOrders}`}>
            <OpenOrder />
          </div>
          
       
          <div className={`${styles.componentCard} ${styles.timeline}`}>
            <Timeline />
          </div> */}
          
          {/* Category */}
          <div className={`${styles.componentCard} ${styles.category}`}>
            <Category />
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Home;